import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  FpOverviewData,
  FpOverviewDataShownGroups, FundPerformanceOverview, SelectedFundsAmount,
} from "../../../organization/components/organization-overview/utils";
import { NgForOf, NgIf } from "@angular/common";
import { SharedComponentsModule } from "../../module/shared-components.module";
import { FundsSelectorDropdownService } from "./FundsSelectorDropdown.service";

@Component({
  selector: 'app-funds-selector-dropdown',
  standalone: true,
  imports: [
    NgForOf,
    NgIf,
    SharedComponentsModule,
  ],
  templateUrl: './funds-selector-dropdown.component.html',
  styleUrl: './funds-selector-dropdown.component.scss',
})
export class FundsSelectorDropdownComponent {
  protected readonly shownGroups = FpOverviewDataShownGroups;

  @Input() selectedFundsAmount = new SelectedFundsAmount();
  @Input() fundsData: FpOverviewData;
  @Output() selectedFundsAmountChange = new EventEmitter<SelectedFundsAmount>();
  @Output() fundsDataChange = new EventEmitter<FpOverviewData>();

  constructor(private fundsSelectorDropdownService: FundsSelectorDropdownService) {}

  toggleFund(fund: FundPerformanceOverview): void {
    fund.isShown = !fund.isShown;
    this.fundsSelectorDropdownService.setFundsData(this.fundsData);
    this.fundsDataChange.emit(this.fundsData);
    this.countSelected();
  }

  toggleAllFunds(): void {
    const atLeastOneIsActive = Boolean(this.fundsData.all.find((f) => f.isShown));
    const atLeastOneIsNotActive = Boolean(this.fundsData.all.find((f) => !f.isShown));
    if (atLeastOneIsActive && !atLeastOneIsNotActive) {
      this.fundsData.all.forEach((f) => f.isShown = false);
    } else {
      this.fundsData.all.forEach((f) => f.isShown = true);
    }
    this.fundsSelectorDropdownService.setFundsData(this.fundsData);
    this.fundsDataChange.emit(this.fundsData);
    this.countSelected();
  }

  countSelected(): void {
    this.selectedFundsAmount.all = this.fundsData.all.filter((f) => f.isShown).length;
    this.selectedFundsAmount.spvs = this.fundsData.spvs.filter((f) => f.isShown).length;
    this.selectedFundsAmount.funds = this.fundsData.funds.filter((f) => f.isShown).length;
    this.selectedFundsAmountChange.emit(this.selectedFundsAmount);
  }
}
